enum RoomSettingsFacilities {
    Beamer = "Beamer",
    Tv = "Tv",
    Flipchart = "Flipchart",
    Whiteboard = "Whiteboard",
    Videoconferencing = "Videoconferencing"
}

export default RoomSettingsFacilities;